<div >
<!--  <h4>{{header}}</h4>-->
  <div id="doc-geocharts"  align="center" >
    <google-chart #mygeochart [data]="geoChart" ></google-chart>
  </div>
</div>

